var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1222_32460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.36 6.00004H1.63996C1.49695 5.99882 1.35534 6.0283 1.22468 6.08648C1.09403 6.14465 0.977381 6.23018 0.8826 6.33728C0.787819 6.44439 0.717114 6.57057 0.675256 6.70733C0.633399 6.84409 0.621363 6.98823 0.639961 7.13004L1.36996 12.63C1.40169 12.8721 1.5209 13.0943 1.70511 13.2545C1.88932 13.4148 2.1258 13.5021 2.36996 13.5H11.61C11.8541 13.5021 12.0906 13.4148 12.2748 13.2545C12.459 13.0943 12.5782 12.8721 12.61 12.63L13.34 7.13004C13.3583 6.9899 13.3468 6.84746 13.3061 6.71211C13.2654 6.57675 13.1965 6.45156 13.1039 6.34479C13.0113 6.23801 12.8971 6.15208 12.7689 6.09265C12.6407 6.03323 12.5013 6.00166 12.36 6.00004Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5V11",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5V11",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5V11",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47998 1.54004C10.079 1.64353 10.6278 1.93983 11.043 2.38388C11.4582 2.82792 11.717 3.39542 11.78 4.00004L12 6.00004",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6.00006L2.22 4.00006C2.28712 3.39902 2.54772 2.83607 2.96255 2.39599C3.37738 1.95591 3.92397 1.66254 4.52 1.56006",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.75C9.5 1.91415 9.46767 2.0767 9.40485 2.22835C9.34203 2.38001 9.24996 2.51781 9.13388 2.63388C9.01781 2.74996 8.88001 2.84203 8.72835 2.90485C8.5767 2.96767 8.41415 3 8.25 3H5.75C5.41848 3 5.10054 2.8683 4.86612 2.63388C4.6317 2.39946 4.5 2.08152 4.5 1.75C4.5 1.41848 4.6317 1.10054 4.86612 0.866117C5.10054 0.631696 5.41848 0.5 5.75 0.5H8.25C8.58152 0.5 8.89946 0.631696 9.13388 0.866117C9.3683 1.10054 9.5 1.41848 9.5 1.75Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1222_32460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.fdb82ead7db2414f7ffd1c309bed9b5b.svg";
export { ForwardRef as ReactComponent };